<template>
  <!-- 右边主体[[ -->
  <div class="g-content g-autofixheight personal">
    <div class="personal-top">
      <div class="personal-top-left f-inlineblock-top">
        <span class="ico ico-data-quantity"></span>
        <div class="data-quantity f-inlineblock-top">
          <div class="data-quantity-con">
            <p class="data-quantity-name">总发布量</p>
            <p class="data-quantity-num">{{ info.pub }}</p>
          </div>
          <div class="data-quantity-con">
            <p class="data-quantity-name">总浏览量</p>
            <p class="data-quantity-num">{{ info.pv }}</p>
          </div>
          <div class="data-quantity-con play-quantity">
            <p class="data-quantity-name">总播放量</p>
            <p class="data-quantity-num">{{ info.vv }}</p>
          </div>
        </div>
      </div>
      <div class="personal-top-right f-inlineblock-top">
        <span class="ico ico-profit"></span>
        <div class="data-quantity f-inlineblock-top">
          <div class="data-quantity-con release-quantity">
            <p class="data-quantity-name">
              总收益<span
                class="ico ico-eye js-eye"
                :class="{ 'ico-eye-active': !showMoney }"
                @click="showMoney = !showMoney"
              ></span>
            </p>
            <p class="data-quantity-num js-num" v-if="showMoney">
              &yen;{{ income }}
            </p>
            <p class="data-quantity-asterisk js-asterisk" v-else>
              <span class="asterisk-text">＊＊＊＊＊</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="personal-con">
      <!-- 广告位 start -->
      <div class="swiper-container banner">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) of swiperList"
            :key="index"
          >
            <a
              :href="item.link || 'javascript:;'"
              :target="item.openNew ? '_blank' : ''"
            >
              <img class="guanggao-img" :src="item.img" />
            </a>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
      </div>
      <!-- 广告位 end -->

      <!-- 系统公告 start -->
      <div class="system-bulletin">
        <h5 class="bulletin-tit f-clearfix">
          <p class="bulletin-tit-text f-fl">系统公告</p>
          <!-- <a class="bulletin-tit-more f-fr" href="javascript:;">更多></a> -->
        </h5>
        <!-- <ul class="bulletin-list">
                    <li class="bulletin-list-con f-clearfix" v-for="item of list" :key="item">
                        <i :class="item.sign" v-if="item.sign">顶</i>
                        <a class="bulletin-list-text f-fl" :href="item.link" target="_blank">{{item.title}}</a>
                        <p class="bulletin-list-time f-fr">{{item.time}}</p>
                    </li>
                </ul> -->
        <ul class="bulletin-list">
          <li
            class="bulletin-list-con f-clearfix"
            v-for="(item, index) of noticeList"
            :key="index"
          >
            <i
              class="top"
              v-if="item.tag && item.tag.toLowerCase().includes('top')"
              >顶</i
            >
            <i
              class="new"
              v-if="item.tag && item.tag.toLowerCase().includes('new')"
              >新</i
            >
            <i
              class="hot"
              v-if="item.tag && item.tag.toLowerCase().includes('hot')"
              >热</i
            >
            <a
              class="bulletin-list-text f-fl"
              href="javascript:;"
              @click="toDetail(item)"
              >{{ item.title }}</a
            >
            <p class="bulletin-list-time f-fr">
              {{ $common.formatDate(item.start_time, "-") }}
            </p>
          </li>
        </ul>
      </div>
      <!-- 系统公告 end -->

      <!-- <ul class="personal-billboard">
                <li class="personal-billboard-con content-list">
                    <a href="javascript:;">
                        <img class="personal-billboard-img" src="~Assets/img/pages/v4/img-17.png"/>
                    </a>
                    <span class="ico ico-content"></span>
                </li>
                <li class="personal-billboard-con content-list">
                    <a href="javascript:;">
                        <img class="personal-billboard-img" src="~Assets/img/pages/v4/img-18.png"/>
                    </a>
                    <span class="ico ico-authors"></span>
                </li>
            </ul> -->
    </div>
  </div>
  <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/personal/personal.scss";
.bulletin-list-con {
  position: relative;
  padding-left: 20px;
}
.top,
.new,
.hot {
  color: #fff;
  position: absolute;
  line-height: 1.2;
  padding: 0 1px;
  left: 0;
  top: 2px;
}
.top {
  background-color: #009cff;
}
.new {
  background-color: #ff8400;
}
.hot {
  background-color: #ff2500;
}
</style>
<script>
import Swiper from "Assets/vendor/swiper/swiper-3.2.7.min.js";
import {
  UserCenter,
  AnnounceQqlist,
  UserCenterIncome,
} from "Services/getData.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      info: {
        pub: 0,
        pv: 0,
        vv: 0,
      },
      income: 0,
      showMoney: false,
      list: [],
      mySwiper: "",
      swiperList: [
        {
          img: require("../../../assets/img/pages/v4/activity/peace/banner2.jpg"),
          link: "//tgl.qq.com/activity/#/center/contribute/contribute",
          openNew: false,
        },
        // {
        //     img: require('../../../assets/img/pages/v4/activity/lol/banner.png'),
        //     link: '//tgl.qq.com/activity/#/center/activity/lol',
        // },
        // {
        //     img: require('../../../assets/img/pages/v4/activity/cf/banner_cf.png'),
        //     link: '//tgl.qq.com/activity/#/center/activity/cf/pc',
        // },
        // {
        //     img: require('../../../assets/img/pages/v4/activity/school_creator/banner.png'),
        //     link: '//tgl.qq.com/activity/#/center/activity/school_winner',
        // },
        // {
        //     img: '/assets/images/banner_notice.png',
        //     link: '/notice/course.shtml',
        // },
      ],
    };
  },
  mounted() {
    this.initSwiper();
    this.getData();
    this.getProfit();
  },
  computed: {
    ...mapGetters(["noticeList"]),
  },
  methods: {
    async getProfit() {
      let res = await UserCenterIncome();
      if (res.status == 200 && res.data.code == 0) {
        this.income = res.data.data.income;
      }
    },
    toDetail(item) {
      if (item.announce_type == 1) {
        this.$router.push({
          name: "v4-notice-detail",
          params: {
            id: item.id,
          },
        });
      } else {
        window.open(item.content, "_blank");
      }
    },
    async getList() {
      let res = await AnnounceQqlist();
      if (res.data.code == 0) {
        this.list = res.data.data;
        this.list.filter((item) => {
          return item.tag.toLowerCase().includes("new");
        }).length;
      }
    },
    initSwiper() {
      // Swiper轮播
      this.mySwiper = new Swiper(".swiper-container.banner", {
        autoplay: 5000,
        direction: "vertical",
        loop: true,
        // autoplayStopOnLast : true,//轮播到最后停止
      });
      // 如果只有一个slide就锁住swiper
      if (this.mySwiper.slides.length <= 3) {
        this.mySwiper.lockSwipes();
      }
    },
    async getData() {
      let res = await UserCenter();
      if (res.status == 200 && res.data.code == 0) {
        this.info = res.data.data;
      }
    },
  },
};
</script>